import { toast } from 'sonner'
import { useConfirm } from '@/components/common/ConfirmDialog'
import { useDeleteStage } from '../hooks'
import type { Stage, StageOwner } from '../types'
import { formatError } from './formatError'

export function StageRow({
  stage,
  owner,
  isSelected,
  onSelect,
  onEdit,
}: {
  stage: Stage
  owner: string | StageOwner
  isSelected: boolean
  onSelect: () => void
  onEdit: (s: Stage) => void
}) {
  const confirm = useConfirm()
  const del = useDeleteStage(owner)

  return (
    <div
      onClick={onSelect}
      className={`flex items-center gap-2 w-full text-left cursor-pointer ${isSelected ? 'text-sky-700 font-medium' : ''}`}
    >
      <span className="flex-1 truncate">{stage.labelPl}</span>
      <span className="font-mono text-[10px] text-slate-400">{stage.code}</span>
      {stage.isTerminal && (
        <span className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-50 text-emerald-700">terminal</span>
      )}
      <span className="ml-1 flex items-center gap-1.5">
        <button
          type="button"
          onClick={e => { e.stopPropagation(); onEdit(stage) }}
          className="text-xs text-slate-600 hover:text-sky-700"
        >Edytuj</button>
        <button
          type="button"
          onClick={async e => {
            e.stopPropagation()
            const ok = await confirm({
              title: `Usunąć etap ${stage.code}?`,
              description: 'Operacja zablokowana jeśli umowy są w tym etapie.',
              confirmLabel: 'Usuń',
              variant: 'destructive',
            })
            if (ok) del.mutate(stage.code, { onError: err => toast.error(formatError(err)) })
          }}
          className="text-xs text-red-600"
        >Usuń</button>
      </span>
    </div>
  )
}
